import * as actions from "../action.constants";

const requestDashboards = () => ({
  type: actions.REQUEST_DASHBOARDS,
});

const storeDashboards = (data) => ({
  type: actions.STORE_DASHBOARDS,
  payload: data,
});

const requestDashboardCellsData = (data) => ({
  type: actions.REQUEST_DASHBOARD_CELLS_DATA,
  payload: data,
});

const storeDashboardCellsData = (data) => ({
  type: actions.STORE_DASHBOARD_CELLS_DATA,
  payload: data,
});

const createDashboard = (data, callBack, updateCallback, name) => ({
  type: actions.CREATE_DASHBOARD,
  payload: data,
  callBack,
  updateCallback,
  name,
});

const updateDashboard = (data, callBack, updateCallback) => ({
  type: actions.UPDATE_DASHBOARD,
  payload: data,
  callBack,
  updateCallback,
});

const updateDashboardCells = (data) => ({
  type: actions.UPDATE_CELLS,
  payload: data,
});

const deleteDashboard = (data, updateCallback) => ({
  type: actions.DELETE_DASHBOARD,
  payload: data,
  updateCallback,
});

const deleteDashboardCell = (data, updateCallback) => ({
  type: actions.DELETE_DASHBOARD_CELL,
  payload: data,
  updateCallback,
});

const requestWidgets = () => ({
  type: actions.REQUEST_WIDGETS,
});

const storeWidgets = (data) => ({
  type: actions.STORE_WIDGETS,
  payload: data,
});

const handoffSnapshot = (payload, callback) => ({
  type: actions.SNAPSHOT_HANDOFF,
  payload,
  callback,
});

const cloneSnapshot = (data, callback) => ({
  type: actions.SNAPSHOT_CLONE,
  payload: data,
  callback,
});

export {
  requestDashboards,
  storeDashboards,
  requestDashboardCellsData,
  storeDashboardCellsData,
  createDashboard,
  updateDashboard,
  deleteDashboard,
  deleteDashboardCell,
  requestWidgets,
  storeWidgets,
  updateDashboardCells,
  handoffSnapshot,
  cloneSnapshot,
};
